import { KatalComponent } from '../../shared/base';

/**
 * @component {kat-input-group} KatalInputgroup Wraps inputs and icons to give a combined control
 * @status Development
 * @guideline Do Use kat-input, kat-icon, and other elements inside the input group to build a control with currency, symbols, and a space for the user to type
 * @guideline Do Be sure to set placeholder and type attributes on your kat-input to hint to users and provide context for assistive devices
 * @contentProvided
 * @example Currency {"content": "<kat-icon name=\"euro_symbol\"><\/kat-icon>\r\n<kat-input placeholder=\"123.45\" type=\"number\"><\/kat-input>"}
 * @example PhoneNumber {"content": "<span id=\"inputGroupFlagSpan\"><kat-flag country=\"us\"><\/kat-flag><\/span>\r\n<span id=\"inputGroupCountryCodeSpan\">+1<\/span>\r\n<kat-input id=\"inputGroupTelephoneInput\" placeholder=\"2223334444\" type=\"tel\"><\/kat-input>\r\n<kat-icon id=\"inputGroupPhoneIcon\" name=\"phone\"><\/kat-icon>"}
 * @example Dropdown {"content": "<kat-input placeholder=\"thing\"></kat-input><kat-dropdown options=\"[{ &quot;name&quot;: &quot;car&quot;,&quot;value&quot;: &quot;carValue&quot;},{&quot;name&quot;: &quot;truck&quot;,&quot;value&quot;: &quot;truckValue&quot;},{&quot;name&quot;: &quot;house&quot;,&quot;value&quot;: &quot;houseValue&quot;}]\"></kat-dropdown>"}
 * @example Email {"content": "<kat-icon class=\"text-storm\" name=\"mail\"><\/kat-icon>\r\n<kat-input placeholder=\"username\" type=\"email\"><\/kat-input>\r\n<span>@amazon.com<\/span>"}
 * @example Password {"content": "<kat-icon name=\"lock\"><\/kat-icon>\r\n<kat-input type=\"password\"><\/kat-input>"}
 */
class KatalInputgroup extends KatalComponent {
  static get observedAttributes() {
    return [];
  }

  // Note: For the spacing attribute we just need the JSON metadata not the actual getter and setter.V
  /**
   * @param {boolean} katal-1-2-spacing-fixes A special compatibility flag that when set removes extra margins around this component and sets its height to
   * the correct default. Note that this will become the default behavior in the next major release of Katal. Take a look at our service bulletin page for
   * more details.
   */
  get katal12SpacingFixes() {
    return this.getBooleanAttribute('katal-1-2-spacing-fixes');
  }

  set katal12SpacingFixes(value) {
    return this.setBooleanAttribute('katal-1-2-spacing-fixes', value);
  }

  constructor() {
    super(KatalInputgroup.observedAttributes);
  }
}

KatalComponent.register('kat-input-group', KatalInputgroup);
